import Press1 from './press-1.svg'
import Press2 from './press-2.svg'
import Press3 from './press-3.svg'
import Press4 from './press-4.svg'
import Press5 from './press-5.svg'
import Press6 from './press-6.svg'
import Press7 from './press-7.svg'
import Press8 from './press-8.svg'
import Press9 from './press-9.svg'
import Press10 from './press-10.svg'

export const Section9Images = {
  Press1,
  Press2,
  Press3,
  Press4,
  Press5,
  Press6,
  Press7,
  Press8,
  Press9,
  Press10,
}
